import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/tariff_by_organization';

export default {
    get(legacy) {
        return axios.get(`${RESOURCE_NAME}/`, {params: {legacy: legacy}})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { tariff_id: payload })
    },
    get_removal_items(payload) {
        return axios.get(`${RESOURCE_NAME}/get-removal-items`, {params: {tariff_id: payload}})
    },
    fill_removals() {
        return axios.get(`${RESOURCE_NAME}/fill-removals`)
    },
}
